import { c as _c } from "react/compiler-runtime";
import Announced from '@/components/Icons/Announced';
import Ended from '@/components/Icons/Ended';
import InForce from '@/components/Icons/InForce';
import InProcess from '@/components/Icons/InProcess';
import Paused from '@/components/Icons/Paused';
import Pending from '@/components/Icons/Pending';
import LogoutIcon from '@bloomberg/web-icons-react/Logout';
import type { HierarchicalDataPoint } from 'bnef';
import type { ReactElement } from 'react';
import type { allowedColorVars } from '../../Atoms/Badge/Badge';
import { Badge } from '../../Atoms/Badge/Badge';
const KNOWN_COLOR_ICONS: Record<string, ReactElement> = {
  red: <Ended />,
  blue: <Announced />,
  purple: <InProcess />,
  pink: <Paused />,
  green: <InForce />,
  yellow: <LogoutIcon />,
  teal: <Pending />
};
const isKnownColor = (color?: string | null): color is allowedColorVars => !!color && color in KNOWN_COLOR_ICONS;
export const AssetStatus = t0 => {
  const $ = _c(6);
  const {
    status,
    number
  } = t0;
  if (!status?.label) {
    return null;
  }
  if (!isKnownColor(status.color)) {
    let t1;
    if ($[0] !== status.label) {
      t1 = <Badge text={status.label} colorVar="default" />;
      $[0] = status.label;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = number ?? KNOWN_COLOR_ICONS[status.color];
  let t2;
  if ($[2] !== status.color || $[3] !== status.label || $[4] !== t1) {
    t2 = <Badge text={status.label} colorVar={status.color} icon={t1} />;
    $[2] = status.color;
    $[3] = status.label;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};